import React, { useState } from 'react'
import axios from 'axios'

import brasao from '../../assets/brasilNav.png'

const NovoAnexo = () => {
    const id = window.location.pathname.slice(20)
    const [dados, setDados] = useState({
        idProcesso: id, user: localStorage.nomeJ, dataCriacao: new Date().toLocaleString()
    })

    const updateField = (e) => {
        const { name, value } = e.target
        if (name === "file") {
            let file = e.target.files[0]
            setDados(prevState => ({
                ...prevState,
                [name]: file
            }))
        } else {
            setDados(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const save = (e) => {
        const url = `/api/anexos/postsJuridico`
        const formData = new FormData()
        formData.append("file", dados.file)
        formData.append("idProcesso", id)
        formData.append("user", dados.user)
        formData.append("nomeArquivo", dados.nomeArquivo)
        // formData.append("tipoAnexo", dados.tipoAnexo)
        formData.append("dataCriacao", dados.dataCriacao)
        if (dados.documento) {
            formData.append("documento", dados.documento)
        }
        axios.post(url, formData)
            .then(res => {
                alert(res.data)
                window.location = `/juridico/processo/${id}`
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }

    return (
        <>
            <img src={brasao} alt="Brasil" className='brasaoPed' />
            <div className='conselho'>CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
            <div className="faixaVerde">
                <div className="formNovoPed">
                    <div className="formMeioNPed">
                        <span className='labelNovoPed'>Nome do Documento</span>
                        <input className="inputNPed"
                            name="nomeArquivo"
                            onChange={e => updateField(e)} />
                        <span className="spanRelatorRevisor">Arquivo</span>
                        <input type="file" className="fileAnexo"
                            name="file"
                            onChange={e => updateField(e)} />
                    </div>
                </div>
                <button className="botaoNPed" onClick={e => save(e)}>ENVIAR</button>
            </div>
        </>
    )
}

export default NovoAnexo